const FOCUSABLE_SELECTOR =
	'a[href], area[href], input, select, textarea, button, iframe, object, embed, summary, [tabindex], [contenteditable]:not([contenteditable="false"]), audio[controls], video[controls], .focusable';

const originalTabIndices = new WeakMap();

export default function setTabFocusable(elem, focusable) {
	const elements = [...elem.querySelectorAll(FOCUSABLE_SELECTOR)];
	if (elem.matches(FOCUSABLE_SELECTOR)) {
		elements.unshift(elem);
	}

	// Carousel neighbours must still respond to pointer clicks. Only suppress
	// tab stops here; fully hidden navigation panels use inert instead.
	elements.forEach((element) => {
		if (!focusable) {
			if (!originalTabIndices.has(element)) {
				originalTabIndices.set(
					element,
					element.getAttribute('tabindex')
				);
			}
			element.setAttribute('tabindex', '-1');
		} else if (originalTabIndices.has(element)) {
			const original = originalTabIndices.get(element);
			if (original === null) {
				element.removeAttribute('tabindex');
			} else {
				element.setAttribute('tabindex', original);
			}
			originalTabIndices.delete(element);
		}
	});
}
